import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useCurrentUser } from 'customHooks/useCurrentUser';
import { ActivityItem } from 'types/domain';

interface CreatedByLabelProps {
    createdBy: ActivityItem['created_by'];
}

const CreatedByLabel = ({ createdBy }: CreatedByLabelProps) => {
    const { id: currentUserId } = useCurrentUser();
    const { name } = useCurrentAccount();

    if (!createdBy) {
        return name;
    }

    if (currentUserId === createdBy.id) {
        return 'You';
    }

    return `${createdBy.first_name} ${createdBy.last_name}`;
};

export { CreatedByLabel };
